import { useCallback } from 'react';
import { signIn, type SignInInput } from 'aws-amplify/auth';
import { isSameDomain } from '../utils/auth';

export const useAuthServices = () => {
    const handleSignIn = useCallback(async (formData: SignInInput) => {
        try {
            const { username, password } = formData;
            if (username && password) {
                const result = await signIn({
                    username,
                    password,
                    options: {
                        authFlowType: 'USER_PASSWORD_AUTH'
                    }
                });
                if (result.isSignedIn) {
                    // Amplifyが自動的にクッキーを管理するため、手動操作は不要
                    // リダイレクト処理のみ実行
                    const urlParams = new URLSearchParams(window.location.search);
                    const redirectUri = urlParams.get('redirect_uri');
                    if (redirectUri && isSameDomain(redirectUri)) {
                        window.location.href = redirectUri;
                    }
                }
                return result;
            } else {
                throw new Error('Username and password are required');
            }
        } catch (error) {
            console.error('Error during sign in:', error);
            throw error;
        }
    }, []);

    return {
        handleSignIn,
    };
};